// UN Member Countries — canonical source of truth.
// Each row holds an ISO-like short code, the English name (canonical form
// stored in DB), and the Turkish label (display-only).
// Frontend submits `code`; backend stores `country_code` + `country` (EN).

export const COUNTRIES = [
  { code: 'AF', en: 'Afghanistan',                       tr: 'Afganistan' },
  { code: 'AL', en: 'Albania',                           tr: 'Arnavutluk' },
  { code: 'DZ', en: 'Algeria',                           tr: 'Cezayir' },
  { code: 'AD', en: 'Andorra',                           tr: 'Andorra' },
  { code: 'AO', en: 'Angola',                            tr: 'Angola' },
  { code: 'AG', en: 'Antigua and Barbuda',               tr: 'Antigua ve Barbuda' },
  { code: 'AR', en: 'Argentina',                         tr: 'Arjantin' },
  { code: 'AM', en: 'Armenia',                           tr: 'Ermenistan' },
  { code: 'AU', en: 'Australia',                         tr: 'Avustralya' },
  { code: 'AT', en: 'Austria',                           tr: 'Avusturya' },
  { code: 'AZ', en: 'Azerbaijan',                        tr: 'Azerbaycan' },
  { code: 'BS', en: 'Bahamas',                           tr: 'Bahamalar' },
  { code: 'BH', en: 'Bahrain',                           tr: 'Bahreyn' },
  { code: 'BD', en: 'Bangladesh',                        tr: 'Bangladeş' },
  { code: 'BB', en: 'Barbados',                          tr: 'Barbados' },
  { code: 'BY', en: 'Belarus',                           tr: 'Belarus' },
  { code: 'BE', en: 'Belgium',                           tr: 'Belçika' },
  { code: 'BZ', en: 'Belize',                            tr: 'Belize' },
  { code: 'BJ', en: 'Benin',                             tr: 'Benin' },
  { code: 'BT', en: 'Bhutan',                            tr: 'Bhutan' },
  { code: 'BO', en: 'Bolivia',                           tr: 'Bolivya' },
  { code: 'BA', en: 'Bosnia and Herzegovina',            tr: 'Bosna-Hersek' },
  { code: 'BW', en: 'Botswana',                          tr: 'Botsvana' },
  { code: 'BR', en: 'Brazil',                            tr: 'Brezilya' },
  { code: 'BN', en: 'Brunei',                            tr: 'Brunei' },
  { code: 'BG', en: 'Bulgaria',                          tr: 'Bulgaristan' },
  { code: 'BF', en: 'Burkina Faso',                      tr: 'Burkina Faso' },
  { code: 'BI', en: 'Burundi',                           tr: 'Burundi' },
  { code: 'CV', en: 'Cabo Verde',                        tr: 'Cabo Verde' },
  { code: 'KH', en: 'Cambodia',                          tr: 'Kamboçya' },
  { code: 'CM', en: 'Cameroon',                          tr: 'Kamerun' },
  { code: 'CA', en: 'Canada',                            tr: 'Kanada' },
  { code: 'CF', en: 'Central African Republic',          tr: 'Orta Afrika Cumhuriyeti' },
  { code: 'TD', en: 'Chad',                              tr: 'Çad' },
  { code: 'CL', en: 'Chile',                             tr: 'Şili' },
  { code: 'CN', en: 'China',                             tr: 'Çin' },
  { code: 'CO', en: 'Colombia',                          tr: 'Kolombiya' },
  { code: 'KM', en: 'Comoros',                           tr: 'Komorlar' },
  { code: 'CD', en: 'Congo (Democratic Republic)',       tr: 'Kongo Demokratik Cumhuriyeti' },
  { code: 'CG', en: 'Congo (Republic)',                  tr: 'Kongo Cumhuriyeti' },
  { code: 'CR', en: 'Costa Rica',                        tr: 'Kosta Rika' },
  { code: 'HR', en: 'Croatia',                           tr: 'Hırvatistan' },
  { code: 'CU', en: 'Cuba',                              tr: 'Küba' },
  { code: 'CY', en: 'Cyprus',                            tr: 'Kıbrıs' },
  { code: 'CZ', en: 'Czech Republic',                    tr: 'Çek Cumhuriyeti' },
  { code: 'DK', en: 'Denmark',                           tr: 'Danimarka' },
  { code: 'DJ', en: 'Djibouti',                          tr: 'Cibuti' },
  { code: 'DM', en: 'Dominica',                          tr: 'Dominika' },
  { code: 'DO', en: 'Dominican Republic',                tr: 'Dominik Cumhuriyeti' },
  { code: 'EC', en: 'Ecuador',                           tr: 'Ekvador' },
  { code: 'EG', en: 'Egypt',                             tr: 'Mısır' },
  { code: 'SV', en: 'El Salvador',                       tr: 'El Salvador' },
  { code: 'GQ', en: 'Equatorial Guinea',                 tr: 'Ekvator Ginesi' },
  { code: 'ER', en: 'Eritrea',                           tr: 'Eritre' },
  { code: 'EE', en: 'Estonia',                           tr: 'Estonya' },
  { code: 'SZ', en: 'Eswatini',                          tr: 'Eswatini' },
  { code: 'ET', en: 'Ethiopia',                          tr: 'Etiyopya' },
  { code: 'FJ', en: 'Fiji',                              tr: 'Fiji' },
  { code: 'FI', en: 'Finland',                           tr: 'Finlandiya' },
  { code: 'FR', en: 'France',                            tr: 'Fransa' },
  { code: 'GA', en: 'Gabon',                             tr: 'Gabon' },
  { code: 'GM', en: 'Gambia',                            tr: 'Gambiya' },
  { code: 'GE', en: 'Georgia',                           tr: 'Gürcistan' },
  { code: 'DE', en: 'Germany',                           tr: 'Almanya' },
  { code: 'GH', en: 'Ghana',                             tr: 'Gana' },
  { code: 'GR', en: 'Greece',                            tr: 'Yunanistan' },
  { code: 'GD', en: 'Grenada',                           tr: 'Grenada' },
  { code: 'GT', en: 'Guatemala',                         tr: 'Guatemala' },
  { code: 'GN', en: 'Guinea',                            tr: 'Gine' },
  { code: 'GW', en: 'Guinea-Bissau',                     tr: 'Gine-Bissau' },
  { code: 'GY', en: 'Guyana',                            tr: 'Guyana' },
  { code: 'HT', en: 'Haiti',                             tr: 'Haiti' },
  { code: 'HN', en: 'Honduras',                          tr: 'Honduras' },
  { code: 'HU', en: 'Hungary',                           tr: 'Macaristan' },
  { code: 'IS', en: 'Iceland',                           tr: 'İzlanda' },
  { code: 'IN', en: 'India',                             tr: 'Hindistan' },
  { code: 'ID', en: 'Indonesia',                         tr: 'Endonezya' },
  { code: 'IR', en: 'Iran',                              tr: 'İran' },
  { code: 'IQ', en: 'Iraq',                              tr: 'Irak' },
  { code: 'IE', en: 'Ireland',                           tr: 'İrlanda' },
  { code: 'IL', en: 'Israel',                            tr: 'İsrail' },
  { code: 'IT', en: 'Italy',                             tr: 'İtalya' },
  { code: 'JM', en: 'Jamaica',                           tr: 'Jamaika' },
  { code: 'JP', en: 'Japan',                             tr: 'Japonya' },
  { code: 'JO', en: 'Jordan',                            tr: 'Ürdün' },
  { code: 'KZ', en: 'Kazakhstan',                        tr: 'Kazakistan' },
  { code: 'KE', en: 'Kenya',                             tr: 'Kenya' },
  { code: 'KI', en: 'Kiribati',                          tr: 'Kiribati' },
  { code: 'KP', en: 'North Korea',                       tr: 'Kuzey Kore' },
  { code: 'KR', en: 'South Korea',                       tr: 'Güney Kore' },
  { code: 'KW', en: 'Kuwait',                            tr: 'Kuveyt' },
  { code: 'KG', en: 'Kyrgyzstan',                        tr: 'Kırgızistan' },
  { code: 'LA', en: 'Laos',                              tr: 'Laos' },
  { code: 'LV', en: 'Latvia',                            tr: 'Letonya' },
  { code: 'LB', en: 'Lebanon',                           tr: 'Lübnan' },
  { code: 'LS', en: 'Lesotho',                           tr: 'Lesoto' },
  { code: 'LR', en: 'Liberia',                           tr: 'Liberya' },
  { code: 'LY', en: 'Libya',                             tr: 'Libya' },
  { code: 'LI', en: 'Liechtenstein',                     tr: 'Lihtenştayn' },
  { code: 'LT', en: 'Lithuania',                         tr: 'Lituanya' },
  { code: 'LU', en: 'Luxembourg',                        tr: 'Lüksemburg' },
  { code: 'MG', en: 'Madagascar',                        tr: 'Madagaskar' },
  { code: 'MW', en: 'Malawi',                            tr: 'Malavi' },
  { code: 'MY', en: 'Malaysia',                          tr: 'Malezya' },
  { code: 'MV', en: 'Maldives',                          tr: 'Maldivler' },
  { code: 'ML', en: 'Mali',                              tr: 'Mali' },
  { code: 'MT', en: 'Malta',                             tr: 'Malta' },
  { code: 'MH', en: 'Marshall Islands',                  tr: 'Marshall Adaları' },
  { code: 'MR', en: 'Mauritania',                        tr: 'Moritanya' },
  { code: 'MU', en: 'Mauritius',                         tr: 'Mauritius' },
  { code: 'MX', en: 'Mexico',                            tr: 'Meksika' },
  { code: 'FM', en: 'Micronesia',                        tr: 'Mikronezya' },
  { code: 'MD', en: 'Moldova',                           tr: 'Moldova' },
  { code: 'MC', en: 'Monaco',                            tr: 'Monako' },
  { code: 'MN', en: 'Mongolia',                          tr: 'Moğolistan' },
  { code: 'ME', en: 'Montenegro',                        tr: 'Karadağ' },
  { code: 'MA', en: 'Morocco',                           tr: 'Fas' },
  { code: 'MZ', en: 'Mozambique',                        tr: 'Mozambik' },
  { code: 'MM', en: 'Myanmar',                           tr: 'Myanmar' },
  { code: 'NA', en: 'Namibia',                           tr: 'Namibya' },
  { code: 'NR', en: 'Nauru',                             tr: 'Nauru' },
  { code: 'NP', en: 'Nepal',                             tr: 'Nepal' },
  { code: 'NL', en: 'Netherlands',                       tr: 'Hollanda' },
  { code: 'NZ', en: 'New Zealand',                       tr: 'Yeni Zelanda' },
  { code: 'NI', en: 'Nicaragua',                         tr: 'Nikaragua' },
  { code: 'NE', en: 'Niger',                             tr: 'Nijer' },
  { code: 'NG', en: 'Nigeria',                           tr: 'Nijerya' },
  { code: 'MK', en: 'North Macedonia',                   tr: 'Kuzey Makedonya' },
  { code: 'NO', en: 'Norway',                            tr: 'Norveç' },
  { code: 'OM', en: 'Oman',                              tr: 'Umman' },
  { code: 'PK', en: 'Pakistan',                          tr: 'Pakistan' },
  { code: 'PW', en: 'Palau',                             tr: 'Palau' },
  { code: 'PA', en: 'Panama',                            tr: 'Panama' },
  { code: 'PG', en: 'Papua New Guinea',                  tr: 'Papua Yeni Gine' },
  { code: 'PY', en: 'Paraguay',                          tr: 'Paraguay' },
  { code: 'PE', en: 'Peru',                              tr: 'Peru' },
  { code: 'PH', en: 'Philippines',                       tr: 'Filipinler' },
  { code: 'PL', en: 'Poland',                            tr: 'Polonya' },
  { code: 'PT', en: 'Portugal',                          tr: 'Portekiz' },
  { code: 'QA', en: 'Qatar',                             tr: 'Katar' },
  { code: 'RO', en: 'Romania',                           tr: 'Romanya' },
  { code: 'RU', en: 'Russia',                            tr: 'Rusya' },
  { code: 'RW', en: 'Rwanda',                            tr: 'Ruanda' },
  { code: 'KN', en: 'Saint Kitts and Nevis',             tr: 'Saint Kitts ve Nevis' },
  { code: 'LC', en: 'Saint Lucia',                       tr: 'Saint Lucia' },
  { code: 'VC', en: 'Saint Vincent and the Grenadines',  tr: 'Saint Vincent ve Grenadinler' },
  { code: 'WS', en: 'Samoa',                             tr: 'Samoa' },
  { code: 'SM', en: 'San Marino',                        tr: 'San Marino' },
  { code: 'ST', en: 'Sao Tome and Principe',             tr: 'Sao Tome ve Principe' },
  { code: 'SA', en: 'Saudi Arabia',                      tr: 'Suudi Arabistan' },
  { code: 'SN', en: 'Senegal',                           tr: 'Senegal' },
  { code: 'RS', en: 'Serbia',                            tr: 'Sırbistan' },
  { code: 'SC', en: 'Seychelles',                        tr: 'Seyşeller' },
  { code: 'SL', en: 'Sierra Leone',                      tr: 'Sierra Leone' },
  { code: 'SG', en: 'Singapore',                         tr: 'Singapur' },
  { code: 'SK', en: 'Slovakia',                          tr: 'Slovakya' },
  { code: 'SI', en: 'Slovenia',                          tr: 'Slovenya' },
  { code: 'SB', en: 'Solomon Islands',                   tr: 'Solomon Adaları' },
  { code: 'SO', en: 'Somalia',                           tr: 'Somali' },
  { code: 'ZA', en: 'South Africa',                      tr: 'Güney Afrika' },
  { code: 'SS', en: 'South Sudan',                       tr: 'Güney Sudan' },
  { code: 'ES', en: 'Spain',                             tr: 'İspanya' },
  { code: 'LK', en: 'Sri Lanka',                         tr: 'Sri Lanka' },
  { code: 'SD', en: 'Sudan',                             tr: 'Sudan' },
  { code: 'SR', en: 'Suriname',                          tr: 'Surinam' },
  { code: 'SE', en: 'Sweden',                            tr: 'İsveç' },
  { code: 'CH', en: 'Switzerland',                       tr: 'İsviçre' },
  { code: 'SY', en: 'Syria',                             tr: 'Suriye' },
  { code: 'TW', en: 'Taiwan',                            tr: 'Tayvan' },
  { code: 'TJ', en: 'Tajikistan',                        tr: 'Tacikistan' },
  { code: 'TZ', en: 'Tanzania',                          tr: 'Tanzanya' },
  { code: 'TH', en: 'Thailand',                          tr: 'Tayland' },
  { code: 'TL', en: 'Timor-Leste',                       tr: 'Timor-Leste' },
  { code: 'TG', en: 'Togo',                              tr: 'Togo' },
  { code: 'TO', en: 'Tonga',                             tr: 'Tonga' },
  { code: 'TT', en: 'Trinidad and Tobago',               tr: 'Trinidad ve Tobago' },
  { code: 'TN', en: 'Tunisia',                           tr: 'Tunus' },
  { code: 'TR', en: 'Türkiye',                           tr: 'Türkiye' },
  { code: 'TM', en: 'Turkmenistan',                      tr: 'Türkmenistan' },
  { code: 'TV', en: 'Tuvalu',                            tr: 'Tuvalu' },
  { code: 'UG', en: 'Uganda',                            tr: 'Uganda' },
  { code: 'UA', en: 'Ukraine',                           tr: 'Ukrayna' },
  { code: 'AE', en: 'United Arab Emirates',              tr: 'Birleşik Arap Emirlikleri' },
  { code: 'GB', en: 'United Kingdom',                    tr: 'Birleşik Krallık' },
  { code: 'US', en: 'United States',                     tr: 'Amerika Birleşik Devletleri' },
  { code: 'UY', en: 'Uruguay',                           tr: 'Uruguay' },
  { code: 'UZ', en: 'Uzbekistan',                        tr: 'Özbekistan' },
  { code: 'VU', en: 'Vanuatu',                           tr: 'Vanuatu' },
  { code: 'VE', en: 'Venezuela',                         tr: 'Venezuela' },
  { code: 'VN', en: 'Vietnam',                           tr: 'Vietnam' },
  { code: 'YE', en: 'Yemen',                             tr: 'Yemen' },
  { code: 'ZM', en: 'Zambia',                            tr: 'Zambiya' },
  { code: 'ZW', en: 'Zimbabwe',                          tr: 'Zimbabwe' },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

// Returns a language-sorted list of { code, label } pairs for dropdowns.
export const getCountryOptions = (lang) => {
  const items = COUNTRIES.map(c => ({ code: c.code, label: lang === 'tr' ? c.tr : c.en }));
  return items.sort((a, b) =>
    a.label.localeCompare(b.label, lang === 'tr' ? 'tr' : 'en', { sensitivity: 'base' }),
  );
};

// Given a code, returns the localized label. Falls back to code itself.
export const getCountryLabel = (code, lang) => {
  if (!code) return '';
  const row = COUNTRIES.find(c => c.code === String(code).toUpperCase());
  if (!row) return code;
  return lang === 'tr' ? row.tr : row.en;
};

// Given any free-text country name (TR or EN, old data), resolves to code.
// Used by the one-time data migration helper and back-compat lookups.
export const resolveCountryCode = (name) => {
  if (!name) return null;
  const s = String(name).trim().toLowerCase();
  const row = COUNTRIES.find(c =>
    c.en.toLowerCase() === s ||
    c.tr.toLowerCase() === s ||
    c.code.toLowerCase() === s
  );
  return row ? row.code : null;
};

// ─── Back-compat shims for components still using the old API ─────────────────
// These return just the display names (old getCountries()) so any callers that
// haven't migrated to country_code yet keep rendering labels correctly.
// Phase 86AZ.50 — Türkiye is pinned to the top of every country list since
// this is the default expected market for the COP 31 Antalya platform.
const _pinTurkiye = (arr, label) => {
  const rest = arr.filter(n => n !== label);
  return [label, ...rest];
};

export const UN_COUNTRIES_EN = _pinTurkiye(
  COUNTRIES.map(c => c.en).sort((a, b) => a.localeCompare(b, 'en')),
  'Türkiye'
);

export const UN_COUNTRIES_TR = _pinTurkiye(
  COUNTRIES.map(c => c.tr).sort((a, b) => a.localeCompare(b, 'tr', { sensitivity: 'base' })),
  'Türkiye'
);

export const getCountries = (lang) => lang === 'tr' ? UN_COUNTRIES_TR : UN_COUNTRIES_EN;
